import React, {Component, PropTypes} from 'react';
import i18next from 'i18next';
import Transition from 'components/utils/transition';

export default class Dialog extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        children: PropTypes.node.isRequired,
        opened: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title
            || nextProps.children !== this.props.children
            || nextProps.opened !== this.props.opened
            || nextProps.onClose !== this.props.onClose;
    }

    render() {
        const {title, children, opened, onClose} = this.props;
        return (
            <Transition name='dialog'>
                {opened && (
                    <div className='cielo24-vwrap-dialog-container'>
                        <div className='cielo24-vwrap-dialog'>
                            <div className='cielo24-vwrap-header'>
                                <div className='cielo24-vwrap-title'>{title}</div>
                                <button
                                    type='button'
                                    className='cielo24-vwrap-close'
                                    onClick={onClose}
                                    aria-label={i18next.t('Close')}
                                >
                                    <i
                                        className='cielo24-vwrap-icon cielo24-vwrap-icon-close-circle-o'
                                        aria-hidden={true}
                                    />
                                </button>
                            </div>
                            {children}
                        </div>
                    </div>
                )}
            </Transition>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/layout/dialog.js